import { Directive, Input, OnInit, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { HtmlTag } from './models';
import { Right } from './models/Rights.enum';
import { RightLevel } from './models/RightLevel.enum';
import { RightsService } from './services/rights.service';

@Directive({ selector: '[apply-write-rights]' })
export class ApplyWriteRightsDirective implements OnInit {

    @Input('apply-write-rights') right: Right;

    constructor(private elementRef: ElementRef,
        private renderer: Renderer2,
        private rightService: RightsService) {
    }


    @HostListener('click', ['$event'])
    public onToggleSort(event: any): void {
        if (this.right !== undefined && !this.rightService.hasReadWriteRights(this.right) && event !== undefined) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
        }
    }

    ngOnInit() {
        const nE = this.elementRef.nativeElement;
        if (this.right !== undefined && !this.rightService.hasReadWriteRights(this.right)) {
            this.renderer.addClass(this.elementRef.nativeElement, 'readonly-user');

            switch (nE.tagName) {
                case HtmlTag.BUTTON:
                    this.elementRef.nativeElement.disabled = true;
                    break;
            }

        }
    }
}
